import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface CopyableMonoProps {
  value: string;
  truncate?: boolean;
  className?: string;
}

function truncateMiddle(s: string, keep = 8): string {
  if (s.length <= keep * 2 + 3) return s;
  return `${s.slice(0, keep)}...${s.slice(-keep)}`;
}

export const CopyableMono: React.FC<CopyableMonoProps> = ({ value, truncate = true, className = '' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 900);
    } catch (_) {}
  };

  const display = truncate ? truncateMiddle(value) : value;

  return (
    <span
      className={`inline-flex items-center gap-1.5 cursor-pointer select-all group ${truncate ? '' : 'flex-wrap'} ${className}`}
      onClick={handleCopy}
      title={value}
    >
      <span
        className='font-mono-pp text-sm'
        style={{ color: 'var(--pp-text)', fontFamily: 'var(--pp-mono)', overflowWrap: truncate ? undefined : 'anywhere' }}
      >
        {display}
      </span>
      <span className='opacity-40 group-hover:opacity-80 transition-opacity' style={{ color: 'var(--pp-text-muted)' }}>
        {copied ? <Check size={13} strokeWidth={2.5} /> : <Copy size={13} strokeWidth={2} />}
      </span>
    </span>
  );
};

export default CopyableMono;
